define('strings',{
	startsWith: function(str, start) {
		return typeof str === 'string' && str.lastIndexOf(start, 0) === 0;
	}
});

